import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { WifiOff, X } from "lucide-react";
import axios, { API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Red bar when the shop's own WhatsApp number is disconnected (receipts, daily report, broadcasts stop).
export default function WaDownBanner({ compact = false }) {
  const { user } = useAuth();
  const [alert, setAlert] = useState(null);
  const [hidden, setHidden] = useState(false);
  const canScan = ["owner", "admin"].includes(user?.role);

  useEffect(() => {
    if (!user) return;
    const load = () => axios.get(`${API}/whatsapp/wa-web/alert`).then(({ data }) => setAlert(data?.show ? data : null)).catch(() => {});
    load();
    const t = setInterval(load, 300000);
    return () => clearInterval(t);
  }, [user]);

  if (!alert || hidden) return null;
  const since = alert.down_since ? new Date(alert.down_since).toLocaleString() : "";
  return (
    <div data-testid="wa-down-banner" className={`${compact ? "mx-2 my-1" : "mb-4"} rounded-lg border border-red-500/60 bg-red-600/20 px-3 py-2 flex items-center gap-3 text-sm`}>
      <WifiOff className="w-4 h-4 text-red-400 shrink-0" />
      <div className="flex-1 min-w-0 text-red-200">
        <span className="font-semibold text-red-300">WhatsApp desconectado · 本店 WhatsApp 已掉线</span>
        <span className="ml-2 text-red-200/80" data-testid="wa-down-since">{since}</span>
        <div className="text-xs text-red-200/80">
          No salen recibos, reporte diario ni envíos · 小票、日报、群发都发不出去。
          {canScan ? " Escanee el QR de nuevo · 请重新扫码" : " Avise al dueño para escanear el QR · 请通知老板重新扫码"}
        </div>
      </div>
      {canScan && (
        <Link to="/admin/whatsapp-web" data-testid="wa-down-scan-btn" className="shrink-0 rounded-md bg-red-500 hover:bg-red-600 px-3 py-1.5 text-white text-xs font-semibold transition-colors">
          Escanear QR · 去扫码
        </Link>
      )}
      <button data-testid="wa-down-dismiss" onClick={() => setHidden(true)} className="shrink-0 text-red-300 hover:text-white transition-colors" aria-label="close">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
